export default __webpack_public_path__ + "static/media/warning--railroad-crossing-with-barriers--g1.10b1d9f7.png";